/* =========================================================
   Luxury Judge.me Reviews Fix V4.2
   Datei: 00-custom-Luxury-Judge-Reviews-Fix-V4-2.js

   WICHTIG:
   - Diese Version ersetzt V4.1, V4.0, V3.9 und den separaten X-Scroll-Fix.
   - Bitte den alten separaten "Luxury Judge.me X-Scroll Fix" nicht zusätzlich laden.
   - Sonst kämpfen zwei Style-Blöcke gegeneinander.

   Fixes V4.2:
   - Kein Scrollbalken bei "Mehr lesen".
   - Text klappt wirklich nach unten auf.
   - Bild/Video bleibt beim Aufklappen auf Desktop unverändert groß.
   - Bild/Video wird nicht mehr mit der höheren Textkarte gestreckt.
   - Karten-Ecken bleiben sauber verrundet.
   - Desktop-Seiten werden weiterhin nicht durch 100vw/Scrollbar abgeschnitten.
   ========================================================= */

(function () {
  "use strict";

  const widgetSelector = ".jdgm-widget.jdgm-cards-carousel";
  const STYLE_ID = "luxury-judge-style-v4-2-stable";
  const DEBUG_LUXURY_JUDGE = false;

  const OLD_STYLE_IDS = [
    "luxury-judge-style",
    "luxury-judge-style-v2",
    "luxury-judge-style-v3",
    "luxury-judge-style-v3-force-fullwidth",
    "luxury-judge-style-v4-stable",
    "luxury-judge-style-v4-1-stable",
    "luxury-judge-x-scroll-safe-fix"
  ];

  if (window.__luxuryJudgeV42Booted) {
    return;
  }

  window.__luxuryJudgeV42Booted = true;

  function getRealViewportWidth() {
    return document.documentElement.clientWidth || window.innerWidth || 0;
  }

  function syncLuxuryViewportWidth() {
    document.documentElement.style.setProperty("--lj-real-vw", getRealViewportWidth() + "px");
  }

  function removeOldLuxuryStyles() {
    OLD_STYLE_IDS.forEach((id) => {
      const old = document.getElementById(id);
      if (old) old.remove();
    });
  }

  function injectDebugStyles() {
    if (!DEBUG_LUXURY_JUDGE) return;
    if (document.getElementById("luxury-judge-debug-style")) return;

    const style = document.createElement("style");
    style.id = "luxury-judge-debug-style";
    style.textContent = `
      ${widgetSelector},
      ${widgetSelector} * { outline: 1px solid rgba(255,0,0,.35) !important; }
      ${widgetSelector} .jdgm-card { outline: 3px solid lime !important; }
      ${widgetSelector} .luxury-review-content { outline: 3px solid cyan !important; }
      ${widgetSelector} .jdgm-text { outline: 3px solid orange !important; }
    `;
    document.head.appendChild(style);
  }

  function getLuxuryCss() {
    return `
      html,
      body {
        max-width: 100% !important;
        overflow-x: clip !important;
      }

      @supports not (overflow-x: clip) {
        html,
        body {
          overflow-x: hidden !important;
        }
      }

      ${widgetSelector} {
        --lj-bg: #050505;
        --lj-card-bg: #070707;
        --lj-gold: #bf9743;
        --lj-text: #f4f0ea;
        --lj-muted: rgba(244,240,234,.55);

        --lj-vw: var(--lj-real-vw, 100vw);
        --lj-visible-cards: 3;
        --lj-gap: 28px;
        --lj-side-space: clamp(104px, 7.2vw, 164px);
        --lj-stage-width: min(1540px, calc(var(--lj-vw) - (var(--lj-side-space) * 2)));
        --lj-card-width: calc((var(--lj-stage-width) - (var(--lj-gap) * (var(--lj-visible-cards) - 1))) / var(--lj-visible-cards));
        --lj-card-height: 215px;
        --lj-media-height: 211px;
        --lj-card-radius: 14px;

        position: relative !important;
        left: 50% !important;
        right: auto !important;
        width: var(--lj-vw) !important;
        max-width: var(--lj-vw) !important;
        min-width: 0 !important;
        margin-left: calc(var(--lj-vw) / -2) !important;
        margin-right: 0 !important;
        padding: 90px 0 96px !important;
        background: var(--lj-bg) !important;
        color: var(--lj-text) !important;
        overflow: hidden !important;
        box-sizing: border-box !important;
        isolation: isolate !important;
        contain: paint !important;
      }

      ${widgetSelector},
      ${widgetSelector} *,
      ${widgetSelector} *::before,
      ${widgetSelector} *::after {
        box-sizing: border-box !important;
      }

      ${widgetSelector} .jdgm-header {
        width: var(--lj-stage-width) !important;
        max-width: var(--lj-stage-width) !important;
        margin: 0 auto 50px !important;
        padding: 0 !important;
        text-align: center !important;
        color: var(--lj-text) !important;
      }

      ${widgetSelector} .jdgm-header h2,
      ${widgetSelector} .jdgm-widget-title,
      ${widgetSelector} .jdgm-carousel-title,
      ${widgetSelector} .jdgm-header h2 *,
      ${widgetSelector} .jdgm-widget-title *,
      ${widgetSelector} .jdgm-carousel-title * {
        font-family: Georgia, "Times New Roman", serif !important;
        font-size: clamp(42px, 4vw, 74px) !important;
        line-height: 1.05 !important;
        letter-spacing: .035em !important;
        color: var(--lj-text) !important;
        margin: 0 auto 18px !important;
        white-space: nowrap !important;
        overflow: visible !important;
        text-overflow: clip !important;
        display: block !important;
        max-width: none !important;
      }

      ${widgetSelector} .jdgm-star,
      ${widgetSelector} .jdgm-verified-badge,
      ${widgetSelector} svg {
        color: var(--lj-gold) !important;
        fill: var(--lj-gold) !important;
      }

      ${widgetSelector} .jdgm-cards-wrapper {
        position: relative !important;
        width: var(--lj-stage-width) !important;
        max-width: var(--lj-stage-width) !important;
        min-width: 0 !important;
        margin: 0 auto !important;
        padding: 0 !important;
        overflow: hidden !important;
        border-radius: var(--lj-card-radius) !important;
        box-sizing: border-box !important;
        z-index: 2 !important;
        contain: paint !important;
      }

      ${widgetSelector} .jdgm-cards-wrapper::before,
      ${widgetSelector} .jdgm-cards-wrapper::after {
        display: none !important;
        content: none !important;
      }

      ${widgetSelector} .jdgm-videos-container,
      ${widgetSelector} .jdgm-carousel__track,
      ${widgetSelector} .jdgm-carousel-list,
      ${widgetSelector} .jdgm-cards {
        display: flex !important;
        flex-direction: row !important;
        align-items: flex-start !important;
        gap: var(--lj-gap) !important;
        width: auto !important;
        max-width: none !important;
        min-width: 0 !important;
        padding: 0 !important;
        margin: 0 !important;
        overflow: visible !important;
        box-sizing: border-box !important;
        will-change: transform !important;
        backface-visibility: hidden !important;
        transform-style: preserve-3d !important;
      }

      ${widgetSelector} .jdgm-card {
        flex: 0 0 var(--lj-card-width) !important;
        width: var(--lj-card-width) !important;
        min-width: var(--lj-card-width) !important;
        max-width: var(--lj-card-width) !important;
        height: var(--lj-card-height) !important;
        min-height: var(--lj-card-height) !important;
        max-height: var(--lj-card-height) !important;
        display: flex !important;
        flex-direction: row !important;
        align-items: flex-start !important;
        background: var(--lj-card-bg) !important;
        border: 2px solid rgba(191,151,67,.42) !important;
        border-radius: var(--lj-card-radius) !important;
        overflow: hidden !important;
        color: var(--lj-text) !important;
        box-sizing: border-box !important;
        margin: 0 !important;
        padding: 0 !important;
        transform: translateZ(0) !important;
        isolation: isolate !important;
      }

      /* V4.2:
         Die Karte darf bei "Mehr lesen" höher werden.
         Das Bild/Video bleibt aber fix auf Originalhöhe und wird nicht mitgestreckt. */
      ${widgetSelector} .jdgm-card.luxury-expanded {
        height: auto !important;
        min-height: var(--lj-card-height) !important;
        max-height: none !important;
        overflow: hidden !important;
        align-self: flex-start !important;
        border-radius: var(--lj-card-radius) !important;
      }

      ${widgetSelector} .jdgm-card img,
      ${widgetSelector} .jdgm-card video,
      ${widgetSelector} .jdgm-card .jdgm-video-wrapper,
      ${widgetSelector} .jdgm-card .jdgm-card-media-wrapper {
        flex: 0 0 44% !important;
        width: 44% !important;
        max-width: 44% !important;
        height: var(--lj-media-height) !important;
        min-height: var(--lj-media-height) !important;
        max-height: var(--lj-media-height) !important;
        object-fit: cover !important;
        display: block !important;
        align-self: flex-start !important;
        border-radius: 0 !important;
      }

      ${widgetSelector} .jdgm-card img {
        object-position: center center !important;
      }

      ${widgetSelector} .jdgm-card .jdgm-play-button,
      ${widgetSelector} .jdgm-card [class*="play"] {
        z-index: 5 !important;
      }

      ${widgetSelector} .luxury-review-content {
        flex: 1 1 auto !important;
        min-width: 0 !important;
        min-height: var(--lj-media-height) !important;
        height: auto !important;
        max-height: none !important;
        display: flex !important;
        flex-direction: column !important;
        background: var(--lj-card-bg) !important;
        padding: 24px 24px 19px !important;
        box-sizing: border-box !important;
        align-items: flex-start !important;
        text-align: left !important;
        overflow: visible !important;
      }

      ${widgetSelector} .luxury-review-content .jdgm-touch-overlay,
      ${widgetSelector} .luxury-review-content .jdgm-gradient-overlay {
        pointer-events: none !important;
      }

      ${widgetSelector} .jdgm-rating-section {
        order: 1 !important;
        background: transparent !important;
        padding: 0 0 10px !important;
        margin: 0 !important;
        display: flex !important;
        flex: 0 0 auto !important;
        flex-direction: column !important;
        align-items: flex-start !important;
        text-align: left !important;
        visibility: visible !important;
        opacity: 1 !important;
      }

      ${widgetSelector} .jdgm-stars {
        display: flex !important;
        gap: 2px !important;
        justify-content: flex-start !important;
      }

      ${widgetSelector} .jdgm-card .jdgm-star {
        font-size: 16px !important;
      }

      ${widgetSelector} .jdgm-text {
        order: 2 !important;
        background: transparent !important;
        color: rgba(244,240,234,.96) !important;
        padding: 0 !important;
        margin: 0 !important;
        font-size: 13px !important;
        line-height: 1.42 !important;
        text-align: left !important;
        overflow: hidden !important;
        max-height: 78px !important;
        display: block !important;
        width: 100% !important;
        flex: 0 0 auto !important;
      }

      /* V4.2:
         Kein Scrollbalken. Text klappt komplett auf. */
      ${widgetSelector} .jdgm-card.luxury-expanded .jdgm-text,
      ${widgetSelector} .jdgm-card.luxury-expanded .jdgm-text * {
        max-height: none !important;
        height: auto !important;
        overflow: visible !important;
        overflow-y: visible !important;
        overflow-x: visible !important;
        text-overflow: clip !important;
        white-space: normal !important;
        display: block !important;
        -webkit-line-clamp: unset !important;
        line-clamp: unset !important;
        -webkit-box-orient: unset !important;
      }

      ${widgetSelector} .jdgm-text * {
        color: inherit !important;
      }

      ${widgetSelector} .luxury-read-more {
        order: 3 !important;
        display: none;
        margin: 8px 0 0 !important;
        padding: 3px 0 !important;
        border: 0 !important;
        background: transparent !important;
        color: var(--lj-gold) !important;
        font-size: 11px !important;
        font-weight: 700 !important;
        line-height: 1.2 !important;
        text-decoration: underline !important;
        cursor: pointer !important;
        text-align: left !important;
        width: fit-content !important;
        position: relative !important;
        z-index: 999 !important;
        pointer-events: auto !important;
        flex: 0 0 auto !important;
        outline: none !important;
        box-shadow: none !important;
      }

      ${widgetSelector} .luxury-read-more:focus {
        outline: 1px solid rgba(191,151,67,.7) !important;
        outline-offset: 2px !important;
      }

      ${widgetSelector} .luxury-read-more.is-visible {
        display: inline-block !important;
      }

      ${widgetSelector} .jdgm-reviewer-info {
        order: 4 !important;
        margin-top: auto !important;
        padding: 12px 0 0 !important;
        flex: 0 0 auto !important;
      }

      ${widgetSelector} .jdgm-card.luxury-expanded .jdgm-reviewer-info {
        margin-top: 12px !important;
      }

      ${widgetSelector} .jdgm-product-name {
        order: 5 !important;
        padding: 5px 0 0 !important;
        flex: 0 0 auto !important;
      }

      ${widgetSelector} .jdgm-reviewer-info,
      ${widgetSelector} .jdgm-product-name {
        display: flex !important;
        visibility: visible !important;
        opacity: 1 !important;
        justify-content: flex-start !important;
        text-align: left !important;
        margin-left: 0 !important;
        margin-right: auto !important;
      }

      ${widgetSelector} .jdgm-reviewer-info,
      ${widgetSelector} .jdgm-reviewer-info * {
        color: var(--lj-text) !important;
        font-weight: 700 !important;
        font-size: 12px !important;
      }

      ${widgetSelector} .jdgm-product-name,
      ${widgetSelector} .jdgm-product-name * {
        color: var(--lj-muted) !important;
        font-size: 11px !important;
        white-space: nowrap !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        max-width: 220px !important;
      }

      ${widgetSelector} .jdgm-card.jdgm-text-card .luxury-review-content {
        width: 100% !important;
      }

      ${widgetSelector} .jdgm-card.jdgm-text-card .jdgm-text {
        max-height: 88px !important;
      }

      ${widgetSelector} .jdgm-card.jdgm-text-card.luxury-expanded .jdgm-text {
        max-height: none !important;
      }

      ${widgetSelector} .jdgm-arrow {
        position: absolute !important;
        top: 58% !important;
        transform: translateY(-50%) !important;
        color: var(--lj-gold) !important;
        background: rgba(0,0,0,.58) !important;
        border: 1px solid rgba(191,151,67,.52) !important;
        border-radius: 999px !important;
        width: 50px !important;
        max-width: 50px !important;
        height: 50px !important;
        opacity: 1 !important;
        z-index: 60 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        overflow: hidden !important;
      }

      ${widgetSelector} .jdgm-arrow:first-of-type,
      ${widgetSelector} .jdgm-arrow.jdgm-prev,
      ${widgetSelector} .jdgm-prev-badge + .jdgm-arrow {
        left: max(18px, calc((var(--lj-vw) - var(--lj-stage-width)) / 2 - 68px)) !important;
        right: auto !important;
      }

      ${widgetSelector} .jdgm-arrow:last-of-type,
      ${widgetSelector} .jdgm-arrow.jdgm-next {
        right: max(18px, calc((var(--lj-vw) - var(--lj-stage-width)) / 2 - 68px)) !important;
        left: auto !important;
      }

      @media screen and (max-width: 1199px) and (min-width: 750px) {
        ${widgetSelector} {
          --lj-visible-cards: 2;
          --lj-gap: 28px;
          --lj-side-space: clamp(84px, 8vw, 122px);
          --lj-stage-width: min(1120px, calc(var(--lj-vw) - (var(--lj-side-space) * 2)));
        }

        ${widgetSelector} .jdgm-arrow:first-of-type,
        ${widgetSelector} .jdgm-arrow.jdgm-prev,
        ${widgetSelector} .jdgm-prev-badge + .jdgm-arrow {
          left: 18px !important;
          right: auto !important;
        }

        ${widgetSelector} .jdgm-arrow:last-of-type,
        ${widgetSelector} .jdgm-arrow.jdgm-next {
          right: 18px !important;
          left: auto !important;
        }
      }

      @media screen and (max-width: 749px) {
        ${widgetSelector} {
          --lj-visible-cards: 1;
          --lj-gap: 18px;
          --lj-side-space: 38px;
          --lj-stage-width: calc(var(--lj-vw) - 76px);
          --lj-card-width: var(--lj-stage-width);
          --lj-card-height: auto;
          --lj-media-height: min(360px, calc(var(--lj-card-width) * 1.08));
          --lj-card-radius: 16px;

          padding: 58px 0 72px !important;
        }

        ${widgetSelector} .jdgm-header {
          width: min(360px, calc(var(--lj-vw) - 36px)) !important;
          max-width: min(360px, calc(var(--lj-vw) - 36px)) !important;
          padding: 0 !important;
          margin-bottom: 36px !important;
        }

        ${widgetSelector} .jdgm-header h2,
        ${widgetSelector} .jdgm-widget-title,
        ${widgetSelector} .jdgm-carousel-title,
        ${widgetSelector} .jdgm-header h2 *,
        ${widgetSelector} .jdgm-widget-title *,
        ${widgetSelector} .jdgm-carousel-title * {
          font-size: 29px !important;
          line-height: 1.12 !important;
          max-width: 330px !important;
          white-space: normal !important;
        }

        ${widgetSelector} .jdgm-cards-wrapper {
          width: calc(var(--lj-vw) - 30px) !important;
          max-width: calc(var(--lj-vw) - 30px) !important;
          margin-left: auto !important;
          margin-right: auto !important;
          overflow-x: hidden !important;
          overflow-y: hidden !important;
          padding: 0 !important;
          border-radius: 16px !important;
        }

        ${widgetSelector} .jdgm-videos-container,
        ${widgetSelector} .jdgm-carousel__track,
        ${widgetSelector} .jdgm-carousel-list,
        ${widgetSelector} .jdgm-cards {
          gap: var(--lj-gap) !important;
          align-items: stretch !important;
        }

        ${widgetSelector} .jdgm-card,
        ${widgetSelector} .jdgm-card.luxury-expanded {
          width: var(--lj-card-width) !important;
          min-width: var(--lj-card-width) !important;
          max-width: var(--lj-card-width) !important;
          height: auto !important;
          min-height: 0 !important;
          max-height: none !important;
          display: flex !important;
          flex-direction: column !important;
          border: 2px solid rgba(191,151,67,.45) !important;
          border-radius: 16px !important;
          overflow: hidden !important;
          padding-bottom: 18px !important;
        }

        ${widgetSelector} .jdgm-card img,
        ${widgetSelector} .jdgm-card video,
        ${widgetSelector} .jdgm-card .jdgm-video-wrapper,
        ${widgetSelector} .jdgm-card .jdgm-card-media-wrapper {
          flex: none !important;
          width: 100% !important;
          max-width: 100% !important;
          height: var(--lj-media-height) !important;
          min-height: 0 !important;
          max-height: var(--lj-media-height) !important;
          margin: 0 auto !important;
          object-fit: cover !important;
          display: block !important;
          border-radius: 0 !important;
        }

        ${widgetSelector} .luxury-review-content {
          width: 100% !important;
          max-width: 100% !important;
          min-height: 0 !important;
          height: auto !important;
          max-height: none !important;
          margin: 0 auto !important;
          flex: 0 0 auto !important;
          justify-content: flex-start !important;
          align-items: center !important;
          padding: 0 22px !important;
          box-sizing: border-box !important;
          text-align: center !important;
          overflow: visible !important;
        }

        ${widgetSelector} .jdgm-text {
          order: 1 !important;
          padding: 20px 0 8px !important;
          text-align: center !important;
          font-size: 13px !important;
          line-height: 1.32 !important;
          max-height: 132px !important;
        }

        ${widgetSelector} .jdgm-card.luxury-expanded .jdgm-text {
          max-height: none !important;
          overflow: visible !important;
        }

        ${widgetSelector} .jdgm-text *,
        ${widgetSelector} .jdgm-card .jdgm-text,
        ${widgetSelector} .jdgm-card .jdgm-text * {
          text-align: center !important;
        }

        ${widgetSelector} .luxury-read-more {
          order: 2 !important;
          margin: 2px auto 16px !important;
          text-align: center !important;
          font-size: 11px !important;
        }

        ${widgetSelector} .jdgm-rating-section {
          order: 3 !important;
          align-items: center !important;
          justify-content: center !important;
          text-align: center !important;
          padding: 12px 0 0 !important;
          margin-left: auto !important;
          margin-right: auto !important;
          margin-top: 0 !important;
        }

        ${widgetSelector} .jdgm-stars {
          justify-content: center !important;
        }

        ${widgetSelector} .jdgm-reviewer-info {
          order: 4 !important;
          padding: 8px 0 0 !important;
          margin-top: 0 !important;
        }

        ${widgetSelector} .jdgm-card.luxury-expanded .jdgm-reviewer-info {
          margin-top: 0 !important;
        }

        ${widgetSelector} .jdgm-product-name {
          order: 5 !important;
          padding: 5px 0 0 !important;
        }

        ${widgetSelector} .jdgm-reviewer-info,
        ${widgetSelector} .jdgm-product-name {
          align-items: center !important;
          justify-content: center !important;
          text-align: center !important;
          margin-left: auto !important;
          margin-right: auto !important;
        }

        ${widgetSelector} .jdgm-card.jdgm-text-card {
          padding: 34px 0 24px !important;
          min-height: 270px !important;
          justify-content: center !important;
        }

        ${widgetSelector} .jdgm-card.jdgm-text-card .luxury-review-content {
          justify-content: center !important;
        }

        ${widgetSelector} .jdgm-card.jdgm-text-card .jdgm-text {
          padding: 12px 0 8px !important;
          max-height: 160px !important;
        }

        ${widgetSelector} .jdgm-card.jdgm-text-card.luxury-expanded .jdgm-text {
          max-height: none !important;
        }

        ${widgetSelector} .jdgm-arrow,
        ${widgetSelector} .jdgm-carousel__left-arrow,
        ${widgetSelector} .jdgm-carousel__right-arrow,
        ${widgetSelector} [class*="arrow"] {
          display: none !important;
          opacity: 0 !important;
          visibility: hidden !important;
          pointer-events: none !important;
        }
      }

      ${widgetSelector}.luxury-static-reviews .jdgm-arrow {
        display: none !important;
      }

      ${widgetSelector}.luxury-static-reviews .jdgm-cards-wrapper {
        overflow: visible !important;
      }

      ${widgetSelector}.luxury-static-reviews .jdgm-videos-container,
      ${widgetSelector}.luxury-static-reviews .jdgm-carousel__track,
      ${widgetSelector}.luxury-static-reviews .jdgm-carousel-list,
      ${widgetSelector}.luxury-static-reviews .jdgm-cards {
        width: 100% !important;
        max-width: 100% !important;
        transform: none !important;
        transition: none !important;
        justify-content: center !important;
        gap: var(--lj-gap) !important;
      }

      ${widgetSelector}.luxury-static-reviews .jdgm-card.luxury-review-duplicate-hidden {
        display: none !important;
      }

      ${widgetSelector}.luxury-static-reviews .jdgm-card {
        transform: none !important;
      }

      ${widgetSelector}.luxury-static-reviews.luxury-static-count-1 .jdgm-card:not(.luxury-review-duplicate-hidden),
      ${widgetSelector}.luxury-static-reviews.luxury-static-count-2 .jdgm-card:not(.luxury-review-duplicate-hidden) {
        flex-basis: var(--lj-card-width) !important;
        width: var(--lj-card-width) !important;
        min-width: var(--lj-card-width) !important;
        max-width: var(--lj-card-width) !important;
      }

      @media screen and (max-width: 749px) {
        ${widgetSelector}.luxury-static-reviews .jdgm-arrow {
          display: none !important;
        }

        ${widgetSelector}.luxury-static-reviews .jdgm-cards-wrapper::before,
        ${widgetSelector}.luxury-static-reviews .jdgm-cards-wrapper::after {
          display: none !important;
          content: none !important;
        }

        ${widgetSelector}.luxury-static-reviews.luxury-static-count-1 .jdgm-cards-wrapper {
          width: var(--lj-card-width) !important;
          max-width: var(--lj-card-width) !important;
          overflow: hidden !important;
          margin-left: auto !important;
          margin-right: auto !important;
        }

        ${widgetSelector}.luxury-static-reviews.luxury-static-count-2 .jdgm-cards-wrapper {
          width: calc(var(--lj-vw) - 30px) !important;
          max-width: calc(var(--lj-vw) - 30px) !important;
          margin-left: auto !important;
          margin-right: auto !important;
          overflow-x: auto !important;
          overflow-y: hidden !important;
          scroll-snap-type: x mandatory !important;
          -webkit-overflow-scrolling: touch !important;
          scrollbar-width: none !important;
          padding: 0 !important;
          contain: none !important;
        }

        ${widgetSelector}.luxury-static-reviews.luxury-static-count-2 .jdgm-cards-wrapper::-webkit-scrollbar {
          display: none !important;
        }

        ${widgetSelector}.luxury-static-reviews.luxury-static-count-2 .jdgm-videos-container,
        ${widgetSelector}.luxury-static-reviews.luxury-static-count-2 .jdgm-carousel__track,
        ${widgetSelector}.luxury-static-reviews.luxury-static-count-2 .jdgm-carousel-list,
        ${widgetSelector}.luxury-static-reviews.luxury-static-count-2 .jdgm-cards {
          flex-direction: row !important;
          align-items: stretch !important;
          justify-content: flex-start !important;
          gap: 18px !important;
          width: max-content !important;
          max-width: none !important;
          transform: none !important;
          transition: none !important;
          padding: 0 !important;
          margin: 0 !important;
        }

        ${widgetSelector}.luxury-static-reviews.luxury-static-count-1 .jdgm-videos-container,
        ${widgetSelector}.luxury-static-reviews.luxury-static-count-1 .jdgm-carousel__track,
        ${widgetSelector}.luxury-static-reviews.luxury-static-count-1 .jdgm-carousel-list,
        ${widgetSelector}.luxury-static-reviews.luxury-static-count-1 .jdgm-cards {
          width: 100% !important;
          justify-content: center !important;
          gap: 0 !important;
        }

        ${widgetSelector}.luxury-static-reviews .jdgm-card:not(.luxury-review-duplicate-hidden),
        ${widgetSelector}.luxury-static-reviews.luxury-static-count-1 .jdgm-card:not(.luxury-review-duplicate-hidden),
        ${widgetSelector}.luxury-static-reviews.luxury-static-count-2 .jdgm-card:not(.luxury-review-duplicate-hidden) {
          width: var(--lj-card-width) !important;
          min-width: var(--lj-card-width) !important;
          max-width: var(--lj-card-width) !important;
          flex: 0 0 var(--lj-card-width) !important;
          flex-basis: var(--lj-card-width) !important;
          scroll-snap-align: start !important;
        }

        ${widgetSelector}.luxury-static-reviews.luxury-static-count-2 .jdgm-card:not(.luxury-review-duplicate-hidden):last-child {
          margin-right: 16px !important;
        }
      }
    `;
  }

  function injectLuxuryStyles() {
    removeOldLuxuryStyles();

    const css = getLuxuryCss();
    let style = document.getElementById(STYLE_ID);

    if (!style) {
      style = document.createElement("style");
      style.id = STYLE_ID;
      document.head.appendChild(style);
    }

    if (style.textContent !== css) {
      style.textContent = css;
    }
  }

  function setupReadMore(card) {
    const text = card.querySelector(".jdgm-text");
    if (!text) return;

    let button = card.querySelector(".luxury-read-more");

    if (!button) {
      button = document.createElement("button");
      button.type = "button";
      button.className = "luxury-read-more";
      button.textContent = "Read more";
      text.insertAdjacentElement("afterend", button);

      button.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();

        const expanded = card.classList.toggle("luxury-expanded");
        button.textContent = expanded ? "Read less" : "Read more";

        /* V4.2:
           Keine Inline-Werte setzen.
           Das komplette Aufklappen läuft über CSS,
           damit Bildhöhe und Rundungen stabil bleiben. */
        text.style.maxHeight = "";
        text.style.overflow = "";
        text.style.overflowY = "";
        text.style.overflowX = "";
        text.style.textOverflow = "";
        text.style.whiteSpace = "";
        text.style.webkitLineClamp = "";
      });
    }

    requestAnimationFrame(() => {
      const textLength = text.textContent.trim().length;
      const overflowAmount = text.scrollHeight - text.clientHeight;
      const isOverflowing = overflowAmount > 4 || textLength > 95;
      const isExpanded = card.classList.contains("luxury-expanded");

      if (isOverflowing || isExpanded) {
        button.classList.add("is-visible");
      } else {
        button.classList.remove("is-visible");
      }
    });
  }

  function normalizeCardStructure(card) {
    let content = card.querySelector(":scope > .luxury-review-content");

    if (!content) {
      content = document.createElement("div");
      content.className = "luxury-review-content";
      card.appendChild(content);
    }

    const rating = card.querySelector(".jdgm-rating-section");
    const text = card.querySelector(".jdgm-text");
    const reviewer = card.querySelector(".jdgm-reviewer-info");
    const product = card.querySelector(".jdgm-product-name");
    const touch = card.querySelector(".jdgm-touch-overlay");
    const gradient = card.querySelector(".jdgm-gradient-overlay");

    if (rating && rating.parentElement !== content) content.appendChild(rating);
    if (text && text.parentElement !== content) content.appendChild(text);

    setupReadMore(card);

    const readMore = card.querySelector(".luxury-read-more");
    if (readMore && readMore.parentElement !== content) content.appendChild(readMore);

    if (reviewer && reviewer.parentElement !== content) content.appendChild(reviewer);
    if (product && product.parentElement !== content) content.appendChild(product);
    if (touch && touch.parentElement !== content) content.appendChild(touch);
    if (gradient && gradient.parentElement !== content) content.appendChild(gradient);
  }

  function getReviewSignature(card) {
    const text = (card.querySelector(".jdgm-text")?.textContent || "").replace(/\s+/g, " ").trim();
    const reviewer = (card.querySelector(".jdgm-reviewer-info")?.textContent || "").replace(/\s+/g, " ").trim();
    const productName = (card.querySelector(".jdgm-product-name")?.textContent || "").replace(/\s+/g, " ").trim();
    const image = card.querySelector("img")?.getAttribute("src") || "";

    return [text, reviewer, productName, image].join("::").toLowerCase();
  }

  function applyStaticModeForFewReviews(widget) {
    const cards = Array.from(widget.querySelectorAll(".jdgm-card"));
    if (!cards.length) return;

    const seen = new Set();
    const uniqueCards = [];

    cards.forEach((card) => {
      card.classList.remove("luxury-review-duplicate-hidden");

      const signature = getReviewSignature(card);

      if (!signature.replace(/:/g, "").trim()) {
        uniqueCards.push(card);
        return;
      }

      if (!seen.has(signature)) {
        seen.add(signature);
        uniqueCards.push(card);
      }
    });

    widget.classList.remove("luxury-static-reviews", "luxury-static-count-1", "luxury-static-count-2");

    if (uniqueCards.length > 0 && uniqueCards.length <= 2) {
      widget.classList.add("luxury-static-reviews", "luxury-static-count-" + uniqueCards.length);

      const keep = new Set(uniqueCards);

      cards.forEach((card) => {
        if (!keep.has(card)) {
          card.classList.add("luxury-review-duplicate-hidden");
        }
      });
    }
  }

  function normalizeWidget(widget) {
    if (!widget) return;

    widget.classList.add("luxury-judge-ready");

    const cards = widget.querySelectorAll(".jdgm-card");

    cards.forEach((card) => {
      const hasImage = !!card.querySelector("img, video, .jdgm-video-wrapper, .jdgm-card-media-wrapper");

      if (!hasImage) {
        card.classList.add("jdgm-text-card");
      } else {
        card.classList.remove("jdgm-text-card");
      }

      normalizeCardStructure(card);
    });

    applyStaticModeForFewReviews(widget);
  }

  function normalizeWidgets() {
    document.querySelectorAll(widgetSelector).forEach(normalizeWidget);
  }

  function runLuxuryJudge() {
    syncLuxuryViewportWidth();
    injectLuxuryStyles();
    normalizeWidgets();
    injectDebugStyles();
  }

  function scheduleRun(delay) {
    window.setTimeout(runLuxuryJudge, delay);
  }

  function debounceRun(key, delay) {
    window.clearTimeout(window[key]);
    window[key] = window.setTimeout(runLuxuryJudge, delay);
  }

  document.addEventListener("DOMContentLoaded", runLuxuryJudge);
  window.addEventListener("load", runLuxuryJudge);

  window.addEventListener("resize", function () {
    syncLuxuryViewportWidth();
    debounceRun("__luxuryJudgeV42ResizeTimer", 160);
  });

  [100, 300, 700, 1200, 2500, 5000, 8000].forEach(scheduleRun);

  let tries = 0;
  const luxuryJudgeInterval = window.setInterval(() => {
    runLuxuryJudge();
    tries += 1;
    if (tries >= 12) window.clearInterval(luxuryJudgeInterval);
  }, 700);

  const bodyObserver = new MutationObserver(function () {
    debounceRun("__luxuryJudgeV42MutationTimer", 140);
  });

  if (document.body) {
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener("DOMContentLoaded", function () {
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    });
  }

  const headObserver = new MutationObserver(function () {
    removeOldLuxuryStyles();

    if (!document.getElementById(STYLE_ID)) {
      injectLuxuryStyles();
    }
  });

  if (document.head) {
    headObserver.observe(document.head, { childList: true });
  }

  console.log("Luxury Judge Reviews Fix V4.2 loaded");
})();
